<div>
    <div class="container-fluid pt-custom pb-5 " style="padding-top: 20px;">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Student Registration</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #studentForm="ngForm" (ngSubmit)="onSubmit(data)" class="pb-3">
                            <!-- <div class="row mt-2">
                                <div class="col-lg-4 col-md-12 col-12">
                                    <label><b>Registration No</b><small style="color: red;"> &nbsp; (if you
                                            already added your registration details,
                                            Enter your Registration No which is already sent to your
                                            email id to display all details) </small>
                                    </label>
                                    <input type="text" class="form-control" #RegistrationNo name="RegistrationNo"
                                        id="RegistrationNo" placeholder="Enter Registration No" maxlength="50" required>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12">
                                    <label class="pt-3"> &nbsp; </label><br />
                                    <button class="btn btn-success custom-font" type="button"
                                        style="margin: 5px;float: left;"
                                        (click)="getStudentByHashcode()">Search</button>

                                    <button class="btn btn-primary custom-font" type="button"
                                        style="margin: 5px;float: left;"
                                        (click)="openpopupRegisteration()">Clear</button>
                                </div>
                            </div> -->
                            <div class="border border-dark bg-custom p-2 mt-2">
                                <h4>School Details</h4>
                                <hr style="margin: 0;">
                            <div class="row mt-2">
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>State</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #StateID="ngModel" ngModel name="StateID"
                                        (ngModelChange)="fillCity($event)" [(ngModel)]="data.StateID" required>
                                        <option *ngFor="let state of states" [value]="state.value"
                                            [selected]="data.StateID == state.value">
                                            {{ state.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.StateID == 0 || data.StateID == undefined" class="error_message"
                                            style="color: red;">
                                            State is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>City</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #CityID="ngModel" ngModel name="CityID"
                                        (ngModelChange)="fillSchoolArea(data.StateID,$event)" [(ngModel)]="data.CityID"
                                        required>
                                        <option *ngFor="let city of cities" [value]="city.value"
                                            [selected]="data.CityID == city.value">
                                            {{ city.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.CityID == 0 || data.CityID == undefined" class="error_message"
                                            style="color: red;">
                                            City is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Area</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #Area="ngModel" ngModel name="Area"
                                        (ngModelChange)="fillSchoolName(data.StateID,data.CityID,$event)"
                                        [(ngModel)]="data.Area" required>
                                        <option *ngFor="let areax of areas" [value]="areax.text"
                                            [selected]="data.Area == areax.text">
                                            {{ areax.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.Area == 'Select' || data.Area == undefined" class="error_message"
                                            style="color: red;">
                                            Area is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>School Name</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #SchoolID="ngModel" ngModel name="SchoolID"
                                        id="SchoolID" (change)="getSchooltByHashcode(data.SchoolID)"
                                        [(ngModel)]="data.SchoolID" required>
                                        <option *ngFor="let school of schools" [value]="school.value"
                                            [selected]="data.SchoolID == school.value">
                                            {{ school.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.SchoolID == 0 || data.SchoolID == undefined"
                                            class="error_message" style="color: red;">
                                            School Name is required
                                        </p>
                                    </span>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>School Details</b></label>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>School code  </b></label>
                                    <input type="text" class="form-control"  name="SchoolCode" value="{{schoolcode}}" disabled>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Area : </b></label>
                                    <input type="text" class="form-control"  name="Area" value="{{area}}" disabled>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>State : </b></label>
                                    <input type="text" class="form-control"  name="State" value="{{state}}" disabled>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Address : </b></label>
                                    <textarea type="text" rows="2" class="form-control"  name="Address" value="{{address}}" disabled>
                                </textarea>
                                </div>
                            </div>
                            <div class="row mt-2">
                               
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>City : </b></label>
                                    <input type="text" class="form-control"  name="City" value="{{city}}" disabled>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Pincode : </b></label>
                                    <input type="text" class="form-control"  name="Pincode" value="{{pincode}}" disabled>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Mobile No : </b></label>
                                    <input type="text" class="form-control"  name="mobno" value="{{mobno}}" disabled>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Mail ID : </b></label>
                                    <input type="text" class="form-control"  name="mailid" value="{{mailid}}" disabled>
                                </div>
                            </div>
                            <!-- <div class="row mt-2">
                               
                            </div> -->
                        </div>
                        <div class="border border-dark bg-custom p-2 mt-2">
                            <h4>Student Details</h4>
                            <hr style="margin: 0;">
                            <div class="row mt-2">
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Student Name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #StudName="ngModel" ngModel name="StudName"
                                        [(ngModel)]="data.StudName" maxlength="300" placeholder="Enter student name"
                                        required>
                                    <span *ngIf="studentForm.submitted && StudName.invalid">
                                        <p *ngIf="StudName.errors.required" class="error_message" style="color: red;">
                                            Student name is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Board</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #BoardID="ngModel" ngModel name="BoardID"
                                        [(ngModel)]="data.BoardID" required>
                                        <option *ngFor="let bor of boards" [value]="bor.value"
                                            [selected]="data.BoardID == bor.value">
                                            {{ bor.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.BoardID == 0 || data.BoardID == undefined" class="error_message"
                                            style="color: red;">
                                            Board is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Standard</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #STDID="ngModel" ngModel name="STDID"
                                        [(ngModel)]="data.STDID" required>
                                        <option *ngFor="let stand of stds" [value]="stand.value"
                                            [selected]="data.STDID == stand.value">
                                            {{ stand.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.STDID == 0 || data.STDID == undefined" class="error_message"
                                            style="color: red;">
                                            Standard is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Contact / mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MobileNo="ngModel" ngModel name="MobileNo"
                                        [(ngModel)]="data.MobileNo" minlength="10" numbersOnly maxlength="10"
                                        placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="studentForm.submitted && MobileNo.invalid">
                                        <p *ngIf="MobileNo.errors.required" class="error_message" style="color: red;">
                                            Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="MobileNo.errors.minlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="MobileNo.errors.maxlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>

                            </div>

                            <div class="row mt-2">
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Student mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MailID="ngModel" ngModel name="MailID"
                                        [(ngModel)]="data.MailID" maxlength="50"
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter school mail id"
                                        required>
                                    <span *ngIf="studentForm.submitted && MailID.invalid">
                                        <p *ngIf="MailID.errors.required" class="error_message" style="color: red;">
                                            School mail id is required
                                        </p>
                                        <p *ngIf="MailID.errors.pattern" class="error_message" style="color: red;">
                                            School mail id is invalid
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Category</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #CategoryID="ngModel" ngModel name="CategoryID"
                                        [(ngModel)]="data.CategoryID" required>
                                        <option *ngFor="let cate of categories" [value]="cate.value"
                                            [selected]="data.CategoryID == cate.value">
                                            {{ cate.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="studentForm.submitted ">
                                        <p *ngIf="data.CategoryID == 0 || data.CategoryID == undefined"
                                            class="error_message" style="color: red;">
                                            Category is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Father Name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #FatherName="ngModel" ngModel
                                        name="FatherName" [(ngModel)]="data.FatherName" maxlength="300"
                                        placeholder="Enter Father name" required>
                                    <span *ngIf="studentForm.submitted && FatherName.invalid">
                                        <p *ngIf="FatherName.errors.required" class="error_message" style="color: red;">
                                            Father name is required
                                        </p>
                                    </span>
                                </div>

                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Father Contact / mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #FatherMobile="ngModel" ngModel
                                        name="FatherMobile" [(ngModel)]="data.FatherMobile" minlength="10" numbersOnly
                                        maxlength="10" placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="studentForm.submitted && FatherMobile.invalid">
                                        <p *ngIf="FatherMobile.errors.required" class="error_message"
                                            style="color: red;">
                                            Father Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="FatherMobile.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Father Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="FatherMobile.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Father Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>

                            </div>

                            <div class="row mt-2">
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Father mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #FatherMail="ngModel" ngModel
                                        name="FatherMail" [(ngModel)]="data.FatherMail" maxlength="50"
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter father mail id"
                                        >
                                    <span *ngIf="studentForm.submitted && FatherMail.invalid">
                                        <!-- <p *ngIf="FatherMail.errors.required" class="error_message" style="color: red;">
                                            Father mail id is required
                                        </p> -->
                                        <p *ngIf="FatherMail.errors.pattern" class="error_message" style="color: red;">
                                            Father mail id is invalid
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Mother Name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MotherName="ngModel" ngModel
                                        name="MotherName" [(ngModel)]="data.MotherName" maxlength="300"
                                        placeholder="Enter Mother name" required>
                                    <span *ngIf="studentForm.submitted && MotherName.invalid">
                                        <p *ngIf="MotherName.errors.required" class="error_message" style="color: red;">
                                            Mother name is required
                                        </p>
                                    </span>
                                </div>

                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Mother Contact / mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MotherMobile="ngModel" ngModel
                                        name="MotherMobile" [(ngModel)]="data.MotherMobile" minlength="10" numbersOnly
                                        maxlength="10" placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="studentForm.submitted && MotherMobile.invalid">
                                        <p *ngIf="MotherMobile.errors.required" class="error_message"
                                            style="color: red;">
                                            Mother Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="MotherMobile.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Mother Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="MotherMobile.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Mother Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Mother mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MotherMail="ngModel" ngModel
                                        name="MotherMail" [(ngModel)]="data.MotherMail" maxlength="50"
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter mother mail id"
                                        >
                                    <span *ngIf="studentForm.submitted && MotherMail.invalid">
                                        <!-- <p *ngIf="MotherMail.errors.required" class="error_message" style="color: red;">
                                            Mother mail id is required
                                        </p> -->
                                        <p *ngIf="MotherMail.errors.pattern" class="error_message" style="color: red;">
                                            Mother mail id is invalid
                                        </p>
                                    </span>
                                </div>
                            </div>
                            </div>
                            <!-- <div class="row mt-2">
                                <botdetect-captcha captchaStyleName="angularBasicCaptcha"></botdetect-captcha>

                                <label>
                                    <span>Retype the characters from the picture:</span>
                                    
                                    <input type="text" id="userCaptchaInput" name="userCaptchaInput" ngModel
                                        #userCaptchaInput="ngModel">
                                </label>
                            </div> -->
                            <div class="mb-3">
                                <button class="btn btn-success" type="submit" style="margin: 5px;">Submit</button>
                                <button class="btn btn-primary" type="button" (click)="resetForm()"
                                    style="margin: 5px;">Clear</button>
                            </div>
                            <div class="row mt-2">
                                <div class="footer-login custom-footer">
                                    <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
                                    <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
     
    </div>
</div>

<ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white;">Please Wait.</p>
</ngx-spinner>